import { ApplicationConfig, inject, provideAppInitializer, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withHashLocation, withInMemoryScrolling } from '@angular/router';
import { provideNgxSkeletonLoader } from 'ngx-skeleton-loader';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { take } from 'rxjs';
import { routes } from './app.routes';
import { httpInterceptor } from './auth/http.interceptor';
import { UserService } from './auth/user.service';

const initApp = () => {
  return inject(UserService).user$.pipe(take(1));
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(), // Testing zoneless change detection
    provideRouter(
      routes,
      withHashLocation(),
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
    ),
    provideHttpClient(withInterceptors([httpInterceptor])),
    provideAppInitializer(initApp),
    provideNgxSkeletonLoader({
      theme: {
        extendsFromRoot: true,
        height: '28px',
      },
    }),
  ],
};
